import { useState, useEffect } from 'react';

import DropdownProps from './type';
import Icon from '../Icon';
import {
  DropdownItemWrapperStyled,
  DropdownWrapperStyled,
  DropdownItemStyled,
  DropdownLabelStyled,
  DropdownButtonStyled,
} from './styled';

const Dropdown = ({ ...props }: DropdownProps) => {
  const {
    value: valueProp,
    label,
    disabled,
    getOptionLabel,
    options,
    placeholder,
    open: openProps,
    onChange: onChangeProps,
    desktopMode,
    hideLabel,
    ...rest
  } = props;
  const [value, setValue] = useState(valueProp);
  const [open, setOpen] = useState(openProps || false);

  const handleClick = (item: string) => {
    if (onChangeProps) onChangeProps(item);
    setValue(item);
    setOpen(false);
  };

  const getValueLabel = () => {
    if (value) {
      return getOptionLabel ? getOptionLabel(value) : `${value}`;
    }
    return placeholder;
  };

  useEffect(() => {
    if (valueProp !== value) {
      setValue(valueProp);
    }
  }, [valueProp]);

  return (
    <DropdownWrapperStyled desktopMode={desktopMode} {...rest}>
      {!hideLabel && (
        <DropdownLabelStyled {...rest}>
          <p>{label}</p>
        </DropdownLabelStyled>
      )}

      <DropdownButtonStyled
        desktopMode={desktopMode}
        disabled={disabled}
        data-testid="dropdownButton"
        open={open}
        onClick={() => setOpen(!open)}
      >
        <p style={{ color: value ? '#0057B8' : '#5B5D71' }}>{getValueLabel()}</p>

        <div
          style={
            open
              ? { transform: 'rotate(180deg)', transitionDuration: '0.5s' }
              : { transform: 'rotate(360deg)', transitionDuration: '0.5s' }
          }
        >
          <Icon name="arrowDownSpecial" {...(value ? { color: '#0057B8' } : {})} />
        </div>
      </DropdownButtonStyled>

      <DropdownItemWrapperStyled open={open} desktopMode={desktopMode} {...rest}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {options.map((item, index) => {
            return (
              <DropdownItemStyled
                desktopMode={desktopMode}
                key={`${item}-${index}`}
                data-testid="dropdownItem"
                {...rest}
                onClick={() => {
                  handleClick(item);
                }}
              >
                <p>{getOptionLabel ? getOptionLabel(item) : `${item}`}</p>
              </DropdownItemStyled>
            );
          })}
        </div>
      </DropdownItemWrapperStyled>
    </DropdownWrapperStyled>
  );
};

Dropdown.defaultProps = {
  options: [],
  desktopMode: false,
};

export default Dropdown;
